/*eslint-disable */
import LayerService from '@/services/layers/LayerService';

import store from '@/store/index';

import filter from 'lodash/filter';

import {
  LayerGroup, LeafletEvent, Marker, point,
} from 'leaflet';
import { IFeatureCollection } from '@/interfaces/IFeatureCollection';
import { IParkingData } from '@/interfaces/IParkingData';
import EventIconMapperService from '@/services/EventIconMapperService';
import { IModalData } from '@/services/layers/IModalData';

export default class EventsLayerService extends LayerService {
  markerIcon = 'parkingi.svg';

  layerType = 'OTHER';

  onClick = (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void => {
    const template = metaData.description;

    const modalData: IModalData = {
      title: metaData.name,
      content: template,
      navigationPoint: undefined,
      lastUpdate: metaData.updateTime,
      icon: EventIconMapperService(metaData.category.eventCode),
    };

    store.commit('displayModal', modalData);
  };

  redrawLayer = (category: string = 'OTHER'): LayerGroup<any> => {
    const points: IFeatureCollection = { ...store.state.events };
    points.features = filter(
      points.features,
      { properties: { category: { eventCode: category } } },
    );
    this.layerType = category;
    return this.generatePruneClusterMarkerLayer(points);
  };

  protected generateHtmlPointTemplate = (metaData: any, leafletMarker: Marker<any>): string => {
    // eslint-disable-next-line global-require
    const eventIcon = EventIconMapperService(this.layerType);

    // usunięte spacje w celu uniknięcia dodania znaków białych które niszczą
    // ikony dodane za pomocą icomoon
    const template: string = `
        <div
            class="map-simple-icon map-simple-icon--event"
            style='background-image: url("${require('@/assets/img/map-icons/' + eventIcon)}")'>
        </div>
      `;

    return template;
  }
}
